import { supabase } from "@/integrations/supabase/client";

/**
 * Returns Authorization headers for Supabase Edge Function calls using the current session.
 * If no session is available, it returns null so callers can handle unauthenticated states gracefully.
 */
export async function getSupabaseAuthHeaders(): Promise<Record<string, string> | null> {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.error("Failed to get Supabase session", error);
    return null;
  }

  const accessToken = data.session?.access_token;
  if (!accessToken) {
    console.warn("No active access token available for authenticated request");
    return null;
  }

  return { Authorization: `Bearer ${accessToken}` };
}
